import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeField,
  initializeForm,
  login,
  autoLoginToggle,
  loadLoginInfo,
} from '../../modules/auth/auth';
import AuthForm from '../../components/auth/AuthForm';
import { withRouter } from 'react-router-dom';
import { check, initUser } from '../../modules/user';
import { readClub, unloadClub, resetReadClubRes, readClubByCenterID, tempSetClub } from '../../modules/clubs/club';
import { connectSocket } from '../../modules/socket/socket';
import { loadClubList, loadAllClubList, tempSetClubs } from '../../modules/clubs/clubs';
import getDataFromUrl from '../../lib/getDataFromUrl';
import client from '../../lib/api/client';
import { loadCenters, loadClubList as loadClubListApi, readClub as readClubApi } from '../../lib/api/clubs';

const LoginForm = ({ history }) => {
  const [error, setError] = useState(null);
  // memberType 3 분기: 'center'면 센터 모드, 'club'면 첫 클럽 선택 후 일반 로그인
  const [memberType3Mode, setMemberType3Mode] = useState(null); // null | 'center' | 'club'

  const dispatch = useDispatch();
  const {
    form,
    auth,
    authError,
    user,
    club,
    clubs,
    initSocketKey,
    socketKey,
    testClubID,
    webInspact,
    readClubRes,
  } = useSelector(({ auth, user, club, clubs, socket }) => ({
    form: auth.login,
    auth: auth.auth,
    authError: auth.authError,
    user: user.user,
    club: club.defaultClub,
    clubs: clubs.clubs,
    readClubRes: club.readClubRes,
    initSocketKey: socket.initSocketKey,
    socketKey: socket.socketKey,
    webInspact: socket.webInspact,
    testClubID: socket.testClubID,
  }));

  const onChange = (e) => {
    const { value, name } = e.target;
    dispatch(
      changeField({
        form: 'login',
        key: name,
        value,
      }),
    );
  };

  const onSubmit = (e) => {
    const { account, password } = form;
    e.preventDefault();
    dispatch(login({ account, password, socketKey }));
    try {
      localStorage.setItem('socketKey', JSON.stringify(socketKey));
    } catch (e) {
      console.log('localstorage is not working');
    }
  };
  //autoLogin
  const onToggle = () => {
    // dispatch(autoLoginToggle());
    // if (form.autoLogin === false) {
    //   localStorage.removeItem('autoLogin');
    // }
  };

  useEffect(() => {
      console.log('useEffect dispatch ')
    localStorage.removeItem('autoLogin');
    localStorage.removeItem('socketKey');
    localStorage.removeItem('user');
    localStorage.removeItem('clubs');
    localStorage.removeItem('club');
    dispatch(initUser());
    dispatch(unloadClub());
    setError(null);
  }, [dispatch]);

  // useEffect(() => {
  //   const { account, password } = form;
  //   if (socketKey) {
  //     dispatch(login({ account, password, socketKey: socketKey }));
  //     try {
  //       localStorage.setItem('socketKey', JSON.stringify(socketKey));
  //     } catch (e) {
  //       console.log('localstorage is not working');
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dispatch, socketKey]);

  useEffect(() => {
    dispatch(connectSocket({ socketKey: initSocketKey }));
  }, [dispatch, initSocketKey]);

  useEffect(() => {
    dispatch(connectSocket({ socketKey: initSocketKey }));
  }, [dispatch, initSocketKey]);

  useEffect(() => {
    if (readClubRes) {
      dispatch(resetReadClubRes(false));
      if (user && user.memberType === 3 && memberType3Mode === 'center') {
        history.push('/dashboard');
      } else {
        history.push('/member?page=1&searchText=');
      }
    }
  }, [readClubRes, user, memberType3Mode, dispatch, history]);

  // NOTE:
  // memberType 3에서 /dashboard로 먼저 이동하면 LoginForm이 언마운트되어
  // clubs 로드 후 readClub 자동 선택(useEffect)이 동작하지 않을 수 있음.
  // => memberType 3 처리에서는 API로 클럽목록/클럽상세를 직접 로드한 뒤,
  //    redux/localStorage에 세팅하고 이동한다.

  useEffect(() => {
    if (authError) {
      setError('에러 발생! 새로고침 후 다시 시도해주세요.');
      return;
    }
    if (auth) {
      console.log(auth, "auth")
      if (auth.result && auth.memberInfo && auth.memberInfo.memberInfo.clubID === 0 && auth.memberInfo.memberInfo.memberType === 1) {
        let user = {
          account: auth.memberInfo.memberInfo.account,
          centerID: auth.memberInfo.memberInfo.centerID,
          memberType: auth.memberInfo.memberInfo.memberType,
          name: auth.memberInfo.memberInfo.name,
          playerID: auth.memberInfo.memberInfo.playerID,
        }
        localStorage.setItem('user', JSON.stringify(user));
        dispatch(
          loadAllClubList({
            playerID: Number(auth.memberInfo.memberInfo.playerID),
            socketKey,
          }),
        );
        dispatch(
          check({
            playerID: auth.memberInfo.memberInfo.playerID,
            centerID: auth.memberInfo.memberInfo.centerID,
            account: auth.memberInfo.memberInfo.account,
            name: auth.memberInfo.memberInfo.name,
            memberType: auth.memberInfo.memberInfo.memberType,
          }),
        );
        console.log('aaaaa')
        history.push('/member?page=1&searchText=');
        return;
      }
      
      if (auth.result === 1 && auth.memberInfo.memberInfo.clubID !== 0 && auth.memberInfo.memberInfo.memberType === 7) {
        setError(
          '웹 접속 권한이 없는 계정입니다. 새로고침 후 관리자 접속 권한이 있는 계정으로 로그인해주세요.',
        );
        return;
      }

      if (auth.result === 1 && auth.memberInfo.memberInfo.memberType == 3) {
        const nextUser = {
          account: auth.memberInfo.memberInfo.account,
          centerID: auth.memberInfo.memberInfo.centerID,
          memberType: auth.memberInfo.memberInfo.memberType,
          name: auth.memberInfo.memberInfo.name,
          playerID: auth.memberInfo.memberInfo.playerID,
        };
        localStorage.setItem('user', JSON.stringify(nextUser));

        // 센터 로드 후 managerFlag로 분기
        (async () => {
          try {
            const centerID = Number(auth.memberInfo.memberInfo.centerID);
            const res = await loadCenters({ socketKey });
            const centerList = Array.isArray(res?.data) ? res.data : [];
            const centerInfo = centerList.find((c) => Number(c.centerID) === centerID);
            const managerFlag = Number(centerInfo?.managerFlag || 0);

            if (managerFlag === 1) {
              setMemberType3Mode('center');
              // 센터 모드: 클럽 목록/첫 클럽 상세를 직접 로드해서 기본 클럽 세팅
              const clubListRes = await loadClubListApi({ centerID, socketKey });
              const clubList = Array.isArray(clubListRes?.data) ? clubListRes.data : [];
              localStorage.setItem('clubs', JSON.stringify(clubList));
              dispatch(tempSetClubs(clubList));

              if (clubList.length > 0) {
                const firstClubId = clubList[0].clubID;
                const firstClubRes = await readClubApi({ clubID: firstClubId, socketKey });
                const firstClub = firstClubRes?.data || null;
                if (firstClub) {
                  localStorage.setItem('club', JSON.stringify(firstClub));
                  dispatch(tempSetClub(firstClub));
                }
              }
              dispatch(
                check({
                  playerID: auth.memberInfo.memberInfo.playerID,
                  centerID: auth.memberInfo.memberInfo.centerID,
                  account: auth.memberInfo.memberInfo.account,
                  name: auth.memberInfo.memberInfo.name,
                  memberType: auth.memberInfo.memberInfo.memberType,
                }),
              );
              history.push('/dashboard');
            } else {
              // managerFlag == 0(또는 1이 아님) => 강제로 memberType을 5로 내려 일반 클럽 계정으로 처리
              const forcedUser = { ...nextUser, memberType: 5 };
              localStorage.setItem('user', JSON.stringify(forcedUser));

              setMemberType3Mode('club');
              // 일반(클럽) 모드: 클럽 목록/첫 클럽 상세를 직접 로드해서 기본 클럽 세팅
              const clubListRes = await loadClubListApi({ centerID, socketKey });
              const clubList = Array.isArray(clubListRes?.data) ? clubListRes.data : [];
              localStorage.setItem('clubs', JSON.stringify(clubList));
              dispatch(tempSetClubs(clubList));

              if (clubList.length > 0) {
                const firstClubId = clubList[0].clubID;
                const firstClubRes = await readClubApi({ clubID: firstClubId, socketKey });
                const firstClub = firstClubRes?.data || null;
                if (firstClub) {
                  localStorage.setItem('club', JSON.stringify(firstClub));
                  dispatch(tempSetClub(firstClub));
                }
              }
              dispatch(
                check({
                  playerID: auth.memberInfo.memberInfo.playerID,
                  centerID: auth.memberInfo.memberInfo.centerID,
                  account: auth.memberInfo.memberInfo.account,
                  name: auth.memberInfo.memberInfo.name,
                  memberType: 5,
                }),
              );
              // 첫 클럽 세팅이 끝났으니 일반 화면으로 이동
              if (clubList.length === 0) {
                history.push('/dashboard');
              } else {
                history.push('/member?page=1&searchText=');
              }
            }
          } catch (e) {
            console.error('memberType3 center load error:', e);
            // 실패 시에도 안전하게 센터 페이지로 보냄
            setMemberType3Mode('center');
            dispatch(
              check({
                playerID: auth.memberInfo.memberInfo.playerID,
                centerID: auth.memberInfo.memberInfo.centerID,
                account: auth.memberInfo.memberInfo.account,
                name: auth.memberInfo.memberInfo.name,
                memberType: auth.memberInfo.memberInfo.memberType,
              }),
            );
            history.push('/dashboard');
          }
        })();
        return;
      }
      else if (auth.result === 1 && auth.memberInfo.memberInfo.clubID !== 0 && auth.memberInfo.memberInfo.memberType !== 7) {
        dispatch(
          readClub({
            clubID: auth.memberInfo.memberInfo.clubID,
            socketKey: socketKey,
          }),
        );
        dispatch(
          check({
            playerID: auth.memberInfo.memberInfo.playerID,
            centerID: auth.memberInfo.memberInfo.centerID,
            account: auth.memberInfo.memberInfo.account,
            name: auth.memberInfo.memberInfo.name,
            memberType: auth.memberInfo.memberInfo.memberType,
          }),
        );
        dispatch(
          loadClubList({
            centerID: auth.memberInfo.memberInfo.centerID,
            socketKey,
          }),
        );
        
      }
      else {
        if (auth === 'invalid') {
          setError('에러 발생! 새로고침 후 다시 시도해주세요.');
          return false;
        }
        if (auth === 20000) {
          setError();
          return;
        }
        if (auth === 10000) {
          setError('서버 점검 중 입니다.');
          return;
        }
        if (auth == 8888) {
          setError(
            '일반회원은 로그인 할 수 없습니다. 새로고침 후 관리자 계정으로 로그인해주세요',
          );
          return;
        }
        if (auth.result === -1) {
          setError('에러 발생! 새로고침 후 다시 시도해주세요.');
          return;
        }
        if (auth.result !== 1) {
          setError('가입하지 않은 아이디이거나, 잘못된 비밀번호입니다.');
          return;
        }
      }
    }
  }, [auth, authError, dispatch, history, socketKey]);
  useEffect(() => {
    if (user && club) {
    //   if (form.autoLogin) {
    //     try {
    //       localStorage.setItem(
    //         'autoLogin',
    //         JSON.stringify({
    //           autoLogin: form.autoLogin,
    //           account: form.account,
    //           password: form.password,
    //         }),
    //       );
    //     } catch (e) {
    //       console.log('localStorage is not working');
    //     }
    //   } else {
    //     try {
    //       localStorage.setItem('autoLogin', JSON.stringify(false));
    //     } catch (error) {
    //       console.log('localStorage is not working');
    //     }
    //   }
      if(testClubID != club.clubID && webInspact == 1) {
        history.push(`/inspact`,);
      } else {
        console.log('bbbbb', club.clubID)
        //history.push('/member');
      }
      try {
        localStorage.setItem('user', JSON.stringify(user));
      } catch (e) {
        console.log('localStorage is not working');
      }
    }
  }, [
    auth,
    club,
    dispatch,
    form.account,
    form.autoLogin,
    form.password,
    history,
    socketKey,
    user,
  ]);

//   useEffect(() => {
//     if (user && club) {
//     //   if (form.autoLogin) {
//     //     try {
//     //       localStorage.setItem(
//     //         'autoLogin',
//     //         JSON.stringify({
//     //           autoLogin: form.autoLogin,
//     //           account: form.account,
//     //           password: form.password,
//     //         }),
//     //       );
//     //     } catch (e) {
//     //       console.log('localStorage is not working');
//     //     }
//     //   } else {
//     //     try {
//     //       localStorage.setItem('autoLogin', JSON.stringify(false));
//     //     } catch (error) {
//     //       console.log('localStorage is not working');
//     //     }
//     //   }
//     //   if(testClubID != club.clubID && webInspact == 1) {
//     //     history.push(`/inspact`,);
//     //   } else {
//     //     console.log('???????')
//     //     history.push('/member');
//     //   }

//     //   try {
//     //     localStorage.setItem('user', JSON.stringify(user));
//     //   } catch (e) {
//     //     console.log('localStorage is not working');
//     //   }
//     }
//   }, [
//     auth,
//     club,
//     dispatch,
//     form.account,
//     //form.autoLogin,
//     form.password,
//     history,
//     socketKey,
//     user,
//   ]);

  /*
  //--> 서버점검
  useEffect(() => {
    if(club && club.clubID) {
      if(socketKey && testClubID != club.clubID && webInspact == 1)
      {
        history.push(`/inspact`,);
      }
    }
  }, [socketKey, initSocketKey]);
  */

  return (
    <AuthForm
      type="login"
      form={form}
      onChange={onChange}
      onSubmit={onSubmit}
      error={error}
      onToggle={onToggle}
    />
  );
};

export default withRouter(LoginForm);
